import {
  Component,
  Input,
  Directive, ContentChildren, QueryList, Output, EventEmitter
} from '@angular/core';

import { NgbModal } from '../../modal/modal.module';


@Directive({ selector: 'clo-app-tray-item' })
export class CloApplicationTrayItem {


  /**
   *  The notification type
   *
   *  Available types include ['transit']
   */
  @Input() link: string;

  @Input() name: string;

  @Input() categoryName: string;

  /**
   *  An image url to display for the app
   *
   */
  @Input() image: string;

}

@Component({
  selector: 'clo-app-tray',
  templateUrl: './application-tray.html',
  styleUrls: ['./application-tray.css']
})
export class CloApplicationTray {
  @ContentChildren(CloApplicationTrayItem) items: QueryList<CloApplicationTrayItem>;
  /**
   * URL to the logo image
   */
  @Input() unread: string;
  @Input() listOfItems: any;
  @Output()
  appListClicked: EventEmitter<any> = new EventEmitter<any>();


  constructor(private modalService: NgbModal) { }

  open(content) {
    this.modalService.open(content, { shouldAnimate: false, windowClass: 'headerModal gridView' });
  }

  openApplication(categoryName: string, itemName: string) {
    this.appListClicked.emit({ 'categoryName': categoryName, 'itemName': itemName });
  }
}
